var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgMenuList = function SvgMenuList(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24.001,
    viewBox: "0 0 24 24.001",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-13115.518 15424.493)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.481 -1.492)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M646.939,462.278a2.94,2.94,0,1,0,2.992,2.94A2.967,2.967,0,0,0,646.939,462.278Zm0,4.694h0a1.755,1.755,0,1,1,1.786-1.756A1.77,1.77,0,0,1,646.939,466.972Z",
    transform: "translate(12473.053 -15885.278)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.162,
    height: 1.707,
    rx: 0.785,
    transform: "translate(13125.838 -15420.871)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.939,470.608a2.94,2.94,0,1,0,2.992,2.94A2.967,2.967,0,0,0,646.939,470.608Zm0,4.694a1.755,1.755,0,1,1,1.786-1.755A1.77,1.77,0,0,1,646.939,475.3Z",
    transform: "translate(12473.053 -15884.549)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.162,
    height: 1.707,
    rx: 0.785,
    transform: "translate(13125.838 -15411.854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.939,478.938a2.94,2.94,0,1,0,2.992,2.94v0A2.966,2.966,0,0,0,646.939,478.938Zm0,4.692v0a1.755,1.755,0,1,1,1.786-1.755A1.77,1.77,0,0,1,646.939,483.632Z",
    transform: "translate(12473.053 -15883.817)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.162,
    height: 1.707,
    rx: 0.785,
    transform: "translate(13125.838 -15402.835)"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMenuList, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/menu-list.8738442c.svg";
export { ForwardRef as ReactComponent };